// ROUND INTRO markup — verbatim from the prototype.
export const roundIntroHTML = /* html */ `
<div id="screenRoundIntro" class="roundintro hidden">
  <div class="ri-sweep"></div>
  <div class="ri-confetti" id="riConfetti"></div>
  <div class="ri-badge" id="riIcon">✝</div>
  <div class="ri-num" id="riNum">Round 1</div>
  <div class="ri-name" id="riName">Catholic Trivia</div>
  <div class="ri-sub" id="riSub">The classics</div>
  <div class="ri-meta" id="riMeta"></div>
  <div class="ri-cameo hidden" id="riCameo"></div>
  <div class="cta"><button class="btn" id="beginRoundBtn">Begin Round</button></div>
</div>`;
